'use client';

import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["items", "className", "selected"];
import { useEffect } from 'react';
import { cn } from "../utils";
import { useDropdownContext } from "./context";
import { DropdownBaseItem } from "./DropdownBaseItem";
import { DropdownBaseList } from "./DropdownBaseList";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * @deprecated Use UsersDropdown or AsyncUsersDropdown instead, unless you need specific functionality not yet supported by these components.
 */
export var DropdownUsersList = function DropdownUsersList(_ref) {
  var items = _ref.items,
    className = _ref.className,
    selected = _ref.selected,
    itemProps = _objectWithoutProperties(_ref, _excluded);
  var _useDropdownContext = useDropdownContext(),
    values = _useDropdownContext.values,
    setItems = _useDropdownContext.setItems;
  useEffect(function () {
    setItems(items.map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        label: item.name,
        type: 'user'
      });
    }));
  }, [items]);
  return /*#__PURE__*/_jsx(DropdownBaseList, {
    selected: selected,
    children: items.map(function (item) {
      var isSelected = values.includes(item.value);
      return /*#__PURE__*/_jsx(DropdownBaseItem, _objectSpread(_objectSpread({
        value: item.value,
        searchKey: item.name,
        isSelected: isSelected,
        className: cn('tw-h-5.6 tw-py-0.8', isSelected && 'tw-bg-neutral-light-300 dark:tw-bg-neutral-dark-600', className)
      }, itemProps), {}, {
        children: /*#__PURE__*/_jsxs("div", {
          className: "tw-flex tw-items-center tw-gap-0.8",
          children: [/*#__PURE__*/_jsx("img", {
            src: item.avatar,
            alt: item.name,
            className: "tw-h-3.2 tw-w-3.2 tw-rounded-full"
          }), /*#__PURE__*/_jsxs("div", {
            className: "tw-flex tw-flex-col tw-justify-between tw-h-4",
            children: [/*#__PURE__*/_jsx("div", {
              className: "tw-font-subtitle5 tw-line-clamp-1",
              children: item.name
            }), /*#__PURE__*/_jsx("div", {
              className: "tw-font-body5 tw-line-clamp-1 tw-text-neutral-light-700 dark:tw-text-neutral-dark-300",
              children: item.position
            })]
          })]
        })
      }), item.value);
    })
  });
};